import { get, post, patch, del } from '../httpMethods';
import { ApiResponse } from '../../types/api';

export interface ClinicalAlert {
  id: string;
  name: string;
  label: string;
  description?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateClinicalAlertDto {
  name: string;
  label: string;
  description?: string;
  isActive?: boolean;
}

export interface UpdateClinicalAlertDto {
  name?: string;
  label?: string;
  description?: string;
  isActive?: boolean;
}

export const clinicalAlertService = {
  getAll: (): Promise<ApiResponse<ClinicalAlert[]>> => {
    return get<ClinicalAlert[]>('/clinical-alerts');
  },

  getActive: (): Promise<ApiResponse<ClinicalAlert[]>> => {
    return get<ClinicalAlert[]>('/clinical-alerts?active=true');
  },

  getOne: (id: string): Promise<ApiResponse<ClinicalAlert>> => {
    return get<ClinicalAlert>(`/clinical-alerts/${id}`);
  },

  create: (data: CreateClinicalAlertDto): Promise<ApiResponse<ClinicalAlert>> => {
    return post<ClinicalAlert>('/clinical-alerts', data);
  },

  update: (id: string, data: UpdateClinicalAlertDto): Promise<ApiResponse<ClinicalAlert>> => {
    return patch<ClinicalAlert>(`/clinical-alerts/${id}`, data);
  },

  remove: (id: string): Promise<ApiResponse<void>> => {
    return del<void>(`/clinical-alerts/${id}`);
  },
};
